import { render, staticRenderFns } from "./SpotlightText.component.vue?vue&type=template&id=14f349d8&scoped=true&lang=pug"
import script from "./SpotlightText.component.vue?vue&type=script&lang=ts"
export * from "./SpotlightText.component.vue?vue&type=script&lang=ts"
import style0 from "./SpotlightText.component.vue?vue&type=style&index=0&id=14f349d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f349d8",
  null
  
)

export default component.exports